import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BASE}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

/**
 * On 401 outside the auth endpoints, stash the current path and bounce to
 * /login?next=<path>. Session refresh is not possible without a fresh Emergent
 * session_id, so the smoothest UX is a clean login round-trip that returns
 * users right back to where they were.
 */
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    const isAuthEndpoint =
      url.includes("/auth/session") ||
      url.includes("/auth/me") ||
      url.includes("/auth/logout");
    if (status === 401 && !isAuthEndpoint && typeof window !== "undefined") {
      const path = window.location.pathname + window.location.search;
      if (!path.startsWith("/login")) {
        sessionStorage.setItem("vgws_next", path);
        // Only redirect from non-login pages; don't loop.
        window.location.replace(`/login?next=${encodeURIComponent(path)}`);
      }
    }
    return Promise.reject(err);
  },
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
